import React from "react";
import CustomersByYearChart from "./CustomersByYearChart";
import ImpiantiByYearChart from "./ImpiantiByYearChart";
import CustomersByLocalityChart from "./CustomersByLocalityChart";
import TopCaldaieChart from "./TopCaldaieChart";
import CustomersSummary from "./CustomersSummary";
import ImpiantiSummary from "./ImpiantiSummary";
import { AccountData } from "../../generated";
import { canRequireUser, getRemainingDays } from "../../login/loginHelpers";
import { SubscriptionExpiringAlert } from "./SubscriptionExpiringAlert";
import SdiPecRequiredAlert from "./SdiPecRequiredAlert";
import RemainingSmsWidget from "./RemainingSmsWidget";
import TopClimaChart from "./TopClimaChart";

const ExpirationReminder: React.FunctionComponent<{ user: AccountData | null }> = ({ user }) => {
    if (user == null) return null;
    const remainingDays = getRemainingDays(user.expiration);
    if (remainingDays > 15) return null;
    return <div className="col-12">
        <SubscriptionExpiringAlert
            remainingDays={remainingDays}
        />
    </div>
}


const DashBoard: React.FunctionComponent<{ user: AccountData | null }> = ({ user }) => {
    return (
        <div className="row">
            <SdiPecRequiredAlert />
            <ExpirationReminder user={user} />
            <div className="col-12 col-md-6 col-lg-5">
                <CustomersSummary />
            </div>
            <div className="col-12 col-md-6 col-lg-5">
                <ImpiantiSummary />
            </div>
            <div className="col-12 col-md-6 col-lg-2">
                <RemainingSmsWidget />
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <div className="card shadow">
                    <div className="card-body">
                        <CustomersByYearChart />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <div className="card shadow">
                    <div className="card-body">
                        <ImpiantiByYearChart />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <div className="card shadow">
                    <div className="card-body">
                        <CustomersByLocalityChart />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <div className="card shadow">
                    <div className="card-body">
                        <TopCaldaieChart />
                    </div>
                </div>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-6">
                <div className="card shadow">
                    <div className="card-body">
                        <TopClimaChart />
                    </div>
                </div>
            </div>


        </div >
    );
}

export default canRequireUser(DashBoard);
